import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TUserClient, TUserClientUpdate, TUserClientResponse, adaptUserClientFromResponse, adaptUserClientToRequest } from '../../types';
import { TSliceInitialState, useAppSelector } from '../../hooks';
import { BACKEND_USER_CLIENT } from '../../backend-paths';


export const userClientUpdateApi = createAsyncThunk(
	`PUT/${BACKEND_USER_CLIENT}/:id`,
	(payload: TUserClientUpdate, thunkApi) => {
		const { data, id } = payload;
		const path = `${BACKEND_USER_CLIENT}/${id}`;
		const dataRequest = adaptUserClientToRequest(data);

		return HttpService.put<TUserClientResponse>(path, dataRequest).then(result => {
			return adaptUserClientFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TUserClient> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const userClientUpdateSlice = createSlice({
	name: 'userClientUpdateSlice',
	initialState,
	reducers: {
		clearUserClientUpdate(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[userClientUpdateApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[userClientUpdateApi.fulfilled.type]: (state, action: PayloadAction<TUserClient>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[userClientUpdateApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useUserClientUpdateSelector = () => useAppSelector(state => state[userClientUpdateSlice.name]);

export const { clearUserClientUpdate } = userClientUpdateSlice.actions;
